export const RENTAL_PORTAL_LISTING_STATUS = {
  closed: 'closed',
  deactivated: 'deactivated',
  draft: 'draft',
  published: 'published',
}

export const RENTAL_PORTAL_LISTING_STATUSES = {
  [RENTAL_PORTAL_LISTING_STATUS.closed]: {
    text: 'RentalPortal.ListingStatusClosedKey',
    textColor: 'var(--color-info)',
  },
  [RENTAL_PORTAL_LISTING_STATUS.deactivated]: {
    text: 'RentalPortal.ListingStatusDeactivatedKey',
    textColor: 'var(--color-warning)',
  },
  [RENTAL_PORTAL_LISTING_STATUS.draft]: {
    text: 'RentalPortal.ListingStatusDraftKey',
    textColor: 'var(--secondary-text-color)',
  },
  [RENTAL_PORTAL_LISTING_STATUS.published]: {
    text: 'RentalPortal.ListingStatusPublishedKey',
    textColor: 'var(--color-success)',
  },
}

export const RENTAL_PORTAL_FACT_SEPARATOR = ' · '

export const RENTAL_PORTAL_VIEWING_STATUS = {
  cancelled: 'cancelled',
  completed: 'completed',
  confirmed: 'confirmed',
  noShow: 'no_show',
  slotOpen: 'slot_open',
}

export const RENTAL_PORTAL_VIEWING_STATUS_SLOT_OPEN =
  RENTAL_PORTAL_VIEWING_STATUS.slotOpen

export const INTEGRATION_CONNECTION_STATUS = {
  connected: 'connected',
  error: 'error',
  needsReauth: 'needs_reauth',
  notConnected: 'not_connected',
}

export const RENTAL_PORTAL_VIEWING_STATUSES = {
  [RENTAL_PORTAL_VIEWING_STATUS_SLOT_OPEN]: {
    text: 'RentalPortal.ViewingStatusSlotOpenKey',
    textColor: 'var(--color-info)',
  },
  cancelled: {
    text: 'RentalPortal.ViewingStatusCancelledKey',
    textColor: 'var(--color-error)',
  },
  completed: {
    text: 'RentalPortal.ViewingStatusCompletedKey',
    textColor: 'var(--secondary-text-color)',
  },
  confirmed: {
    text: 'RentalPortal.ViewingStatusConfirmedKey',
    textColor: 'var(--color-success)',
  },
  no_show: {
    text: 'RentalPortal.ViewingStatusNoShowKey',
    textColor: 'var(--color-warning)',
  },
}

export const RENTAL_PORTAL_VIEWING_OUTCOME_STATUSES = [
  RENTAL_PORTAL_VIEWING_STATUS.completed,
  RENTAL_PORTAL_VIEWING_STATUS.noShow,
]

export const RENTAL_PORTAL_VIEWING_BOOKED_STATUSES = [
  RENTAL_PORTAL_VIEWING_STATUS.confirmed,
  ...RENTAL_PORTAL_VIEWING_OUTCOME_STATUSES,
]
